import { useForm } from "react-hook-form";
import { ArbitrageAbi, contractAddresses } from "../../../../meta";
import {
  useNotificationContext,
  useWingsContractWrite,
  Typography,
  Card,
  MyFormProvider,
  FlexCol,
  Button,
} from "../../../../shared";
import { parseUnits } from "viem";
import { DisplayChiPriceTolerance } from "./DisplayChiPriceTolerance";

export const SetChiPriceTolerance: React.FC = () => {
  const { showNotification } = useNotificationContext();
  const methods = useForm();
  const { reset, handleSubmit } = methods;

  const { writeContractAsync: setChiPriceTolerance, isPending: isSetting } =
    useWingsContractWrite();

  const onSubmit = async (data: any) => {
    await setChiPriceTolerance(
      {
        abi: ArbitrageAbi,
        address: contractAddresses.Arbitrage,
        functionName: "setChiPriceTolerance",
        args: [parseUnits(data.priceTolerance, 2) as any],
      },
      {
        onSuccess: () => {
          reset();
          showNotification({
            status: "success",
            content: <Typography>success</Typography>,
          });
        },
      }
    );
  };

  return (
    <Card className="w-2/3" hasBorder>
      <MyFormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <FlexCol className="w-full p-4 gap-4">
          <DisplayChiPriceTolerance />
          <Typography>Arbitrage / SetChiPriceTolerance /</Typography>
          <FlexCol className="gap-3">
            <input
              {...methods.register("priceTolerance")}
              placeholder="Price Tolerance (2 decimals)"
              type="text"
              step="any"
              className="input input-bordered w-full"
            />
            <Button type="submit" loading={isSetting}>
              Update Arbitrager
            </Button>
          </FlexCol>
        </FlexCol>
      </MyFormProvider>
    </Card>
  );
};
